// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import {getJdpReason, getJdpResolution} from '../../../shared/repositories';
import actions from '../action-list';

export const readJdpReasons = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const reasons = await getJdpReason();

            dispatch({
                data: reasons,
                type: actions.SET_CLAIM_JDP_REASONS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const readJdpResolutions = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const resolutions = await getJdpResolution();

            dispatch({
                data: resolutions,
                type: actions.SET_CLAIM_JDP_RESOLUTIONS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/action-creators/get-jdp-constants.js